<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main max-w max-gl" id="page-content-main">
    <!-- <epay-lib-common-forgotpassword [baseurl]="baseurl">
    </epay-lib-common-forgotpassword> -->

    <forgot-password-common [baseurl]="baseurl"></forgot-password-common>
  </div>
</epay-page-content>
